import React, { FormEvent, useCallback, useState } from 'react'
import Form from 'react-bootstrap/Form'
import FormGroup from 'react-bootstrap/FormGroup'
import FormLabel from 'react-bootstrap/FormLabel'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import ModalHeader from 'react-bootstrap/ModalHeader'
import ModalTitle from 'react-bootstrap/ModalTitle'
import ModalBody from 'react-bootstrap/ModalBody'
import { useDispatch } from 'react-redux'
import { generatePath, useNavigate } from 'react-router-dom'
import { readFileBlob } from 'app/utils/fileUtils'
import { uploadFormAPK } from 'app/services/client'
import { setIsLoading, setLoadingProgress } from 'app/state/appSlice'
import {
    makeTokenFileConfig,
    useTokenHeaderConfig,
} from 'app/services/tokenConfig'
import { APKUploadViewProps } from './types'
import { APP_ROUTES } from 'app/components/AppRouter/routes'
import { handleServerAPIError } from 'app/services/utils'

export const APKUploadView = (props: APKUploadViewProps) => {
    const [file, setFile] = useState<File>()
    const { appId, apkId, isOpen, toggle } = props
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [token] = useTokenHeaderConfig()

    const onUploadProgress = useCallback(
        (progressEvent: ProgressEvent) => {
            let percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
            )
            dispatch(setLoadingProgress(percentCompleted))
        },
        [dispatch, setLoadingProgress],
    )

    const onUpload = useCallback(
        (event: FormEvent<HTMLFormElement>) => {
            event.preventDefault()

            if (file) {
                dispatch(setIsLoading(true))
                const formData = new FormData(event.currentTarget)
                formData.append('name', 'data')
                formData.append('fileName', file.name)
                formData.append('data', file)

                uploadFormAPK(
                    appId,
                    apkId,
                    formData,
                    makeTokenFileConfig(token, file.name, onUploadProgress),
                )
                    .then(() =>
                        navigate(
                            generatePath(APP_ROUTES.APP_DETAILS, { id: appId }),
                        ),
                    )
                    .catch(e => handleServerAPIError(e, dispatch, navigate))
                    .finally(() => {
                        dispatch(setIsLoading(false))
                        dispatch(setLoadingProgress(-1))
                    })
            }
        },
        [
            appId,
            apkId,
            file,
            dispatch,
            setIsLoading,
            readFileBlob,
            uploadFormAPK,
            handleServerAPIError,
            navigate,
            setLoadingProgress,
            onUploadProgress,
        ],
    )

    return (
        <Modal show={isOpen} onHide={toggle} style={{ zIndex: '9000' }}>
            <ModalHeader>
                <ModalTitle>Upload APK</ModalTitle>
            </ModalHeader>
            <ModalBody>
                <Form onSubmit={onUpload}>
                    <FormGroup className="mb-3">
                        <FormLabel>Upload APK</FormLabel>
                        <FormControl
                            type="file"
                            accept=".apk, .xapk, .apks"
                            onChange={(
                                e: React.ChangeEvent<HTMLInputElement>,
                            ) => e.target.files && setFile(e.target.files[0])}
                        />
                    </FormGroup>
                    <Button disabled={!file} type="submit">
                        Upload
                    </Button>
                </Form>
            </ModalBody>
        </Modal>
    )
}
